'use client';
import { useMediaQuery } from '../useMediaQuery/useMediaQuery';

const breakpoints = {
  sm: 480, // sm breakpoint in pixels
  md: 768, // md breakpoint in pixels
  'sm-md': 640, // sm-md breakpoint in pixels
  lg: 1024, // lg breakpoint in pixels
};

type UseIsMobileParams = {
  breakpoint?: keyof typeof breakpoints;
};

function useIsMobile({ breakpoint = 'sm' }: UseIsMobileParams = {}): boolean {
  return useMediaQuery(`(width < ${breakpoints[breakpoint]}px)`);
}

export { useIsMobile };
